import {
  Component,
  EventEmitter,
  Inject,
  Injector, Output,
} from '@angular/core';
import { RXAP_WINDOW_CONTEXT } from '../tokens';
import { ButtonDefinition } from '@rxap/rxjs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'rxap-window-action-bar',
  templateUrl: './window-action-bar.component.html',
  styleUrls: [ './window-action-bar.component.scss' ],
  standalone: true,
  imports: [ MatToolbarModule, MatButton ],
})
export class WindowActionBarComponent {

  public definitions: ButtonDefinition<any>[] | null = null;
  public position = 'start';

  @Output() close = new EventEmitter<void>();

  constructor(@Inject(RXAP_WINDOW_CONTEXT) context: any, public injector: Injector) {
    if (context.windowRef.settings.actions) {
      this.definitions = context.windowRef.settings.actions.definitions;
      this.position = context.windowRef.settings.actions.position || this.position;
    }
  }

}
